import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from "@environments/environment";
import { Subscription } from "rxjs";
import { interval } from "rxjs/internal/observable/interval";
import { startWith, switchMap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class DownloadService {
  constructor(private http: HttpClient, private _snackBar: MatSnackBar) {}

  public timeInterval!: Subscription;

  exportReport(canvasType: any, body: any) {
    let exportUrl;
    if (body.itemId == "null" || body.itemId == null) {
      exportUrl =
        environment.enterpriseUrls.apiEndpoint +
        "/" +
        canvasType +
        "s/" +
        body.id +
        "/download?include=canvasItems,charts&title=" +
        body.title +
        "&fileType=" +
        body.type;
    } else {
      exportUrl =
        environment.enterpriseUrls.apiEndpoint +
        "/charts/" +
        body.itemId +
        "/download?include=canvasItems,charts&title=" +
        body.title +
        "&fileType=" +
        body.type;
    }

    const eventName = canvasType.charAt(0).toUpperCase() + canvasType.slice(1) + " Downloaded";
    const customFields: any = {ReportId: body.id, ItemId: body.itemId};

    Object.keys(customFields).forEach((key: string) => {
      if (!customFields[key] || customFields[key] === "null") {
        delete customFields[key];
      }
    });

    return this.http.get(exportUrl, {
      observe: "response",
      responseType: "blob",
    });
  }

  startExport(
    id: any,
    canvasType: any,
    title: string,
    type: string,
    itemId: any
  ) {
    const body = {
      id: id,
      canvasType: canvasType,
      title: title,
      type: type,
      itemId: itemId,
    };

    this.exportReport(canvasType, body).subscribe(
      (data: any) => {
        this.downLoadFile(title, data.body, type, data.body.type);
        this.openSnackBar("Report exported", true);
      },
      (error) => {
        console.error("error occurred:", error);
        this.openSnackBar(
          "The export of the report failed. Please try again by removing any invalid HTML before downloading.",
          false
        );
      }
    );
  }

  downLoadFile(title: string, data: any, extension: string, type: string) {
    let blob = new Blob([data], { type: type });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);

    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", title + "." + extension);
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
  }

  openSnackBar(message: string, success: boolean = true) {
    let successClass = success ? "canvas-snackbar" : "canvas-snackbar-error";
    this._snackBar.open(message, "", {
      duration: 3000,
      panelClass: [successClass],
    });
  }
}
